// Simple JS library for displaying page content in modal

class Modal {
    constructor(openerSelector, contentSelector = null, wrapperClasses = [], closeOthers = false) {
        this.modal = null;
        this.content = null;
        this.openers = document.querySelectorAll(openerSelector);
        this.contentSelector = contentSelector ?? 'body';
        this.wrapperClasses = wrapperClasses;
        this.promiseCall = null;
        this.closer = null;
        this.closeOthers = closeOthers;

        this.openers && this.openers.forEach(opener => opener.addEventListener('click', e => this.getContent(e, opener)));
    }

    isOpened = () => {
        return this.modal.getAttribute('aria-hidden') === "false";
    }

    getContent = (e, opener) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.promiseCall) {
            this.modal && this.showModal();
            return;
        }

        if (opener.href && opener.href !== "") {
            this.promiseCall = fetch(opener.href)
                .then(response => response.text())
                .then(html => this.createModal(html))
                .catch(err => console.log('Something went wrong.', err));
        } else {
            this.createModal(document.documentElement.innerHTML);
        }
    }

    createModal = (contentHtml) => {
        const parser = new DOMParser(),
            page = parser.parseFromString(contentHtml, 'text/html');
        const content = page.querySelector(this.contentSelector);

        if (this.closeOthers) {
            const models = document.querySelectorAll('aside.Modal');
            for (const elem of models) {
                elem.remove();
            }
        }

        if (!content) {
            return;
        }

        content.removeAttribute('style');
        const modal = document.createElement('aside');
        modal.classList.add('Modal');
        modal.setAttribute('aria-hidden', 'true');

        const inner = document.createElement('div');
        inner.classList.add('ModalInner', 'u-customScrollBar', ...this.wrapperClasses);
        inner.setAttribute('role', 'dialog');
        inner.setAttribute('aria-modal', 'true');
        inner.append(...content.childNodes);
        modal.append(inner);

        const closer = document.createElement('button');
        closer.classList.add('Modal-closer');
        closer.setAttribute('data-modal-closer', '');
        modal.append(closer);

        document.body.append(modal);

        this.content = inner;
        this.closer = closer;
        this.modal = modal;

        this.addEventListeners();
        this.showModal();
    }

    destroyModal = () => {
        if (!this.modal) {
            return;
        }

        this.removeEventListeners();
        this.modal.classList.remove('is-open');
        this.modal.remove();
        this.modal = this.content = this.closer = this.promiseCall = null;
    }

    showModal = () => {
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-not-overflowed');
    }

    closeModal = () => {
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-not-overflowed');

        this.modal.addEventListener('transitionend', () => this.destroyModal(), false);
    }

    closeModalByCloser = (e) => {
        if (this.isOpened() && !this.modal.querySelector('.ModalInner')?.contains(e.target))
            this.closeModal();
    }

    closeModalByKeyboard = (e) => {
        (e.key === "Escape" || e.key === "Esc") && this.closeModal();
    }

    addEventListeners = () => {
        this.closer?.addEventListener('click', this.closeModal);
        document.addEventListener('click', this.closeModalByCloser, { passive: true });
        document.addEventListener('keydown', this.closeModalByKeyboard, { passive: true });
    }

    removeEventListeners = () => {
        this.closer?.removeEventListener('click', this.closeModal);
        document.removeEventListener('click', this.closeModalByCloser, false);
        document.removeEventListener('keydown', this.closeModalByKeyboard, false);
    }
}